import { apiFetch } from '../auth/AuthContext';

function apiError(res, data) {
    let msg = (data && data.error) || `HTTP ${res.status}`;
    if (res.status === 414) {
        msg = 'Request URI too long';
    }
    const err = new Error(msg);
    err.status = res.status;
    err.code = data && data.error;
    return err;
}

/** Stable key for matching a planner session to a cancellation. */
export function cancellationMatchKey({ date, courseCode, kind, start, end }) {
    return [
        date,
        String(courseCode || '').toUpperCase(),
        kind,
        start,
        end,
    ].join('|');
}

export function indexCancellations(list) {
    const map = new Map();
    for (const c of list || []) {
        map.set(cancellationMatchKey(c), c);
    }
    return map;
}

export async function fetchCancelledClasses({ from, to, courses }) {
    const codes = [...new Set((courses || []).filter(Boolean))];
    const params = new URLSearchParams({ from, to });
    if (codes.length > 0) {
        params.set('courses', codes.join(','));
    }
    const res = await apiFetch(`/api/cancelled-classes?${params}`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw apiError(res, data);
    return Array.isArray(data.cancellations) ? data.cancellations : [];
}

export async function createCancelledClass(partial) {
    const res = await apiFetch('/api/cancelled-classes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(partial),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw apiError(res, data);
    return data.cancellation;
}

export async function removeCancelledClass(id) {
    const res = await apiFetch(`/api/cancelled-classes/${encodeURIComponent(id)}`, {
        method: 'DELETE',
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw apiError(res, data);
    return data.id;
}
